module.exports = function(posts) {
	'use strict'
  posts
  .controller('postController', postController)
	postController.$inject = ["tabSessionService","warningAlertService","eventStream","parseOptions","addToOther","authtokenService","$filter","$interval","cleanObj","$timeout","API_URL","postDataService","$http","$attrs","$rootScope","$scope","getDataService","jQuery","$state","refreshtokenService","config","activeClass","alertService","putDataService","$window","serverError",'cleanArray', 'checkArray','keyPressOnlyNumber','offlineError'];
	
  function postController(tabSessionService,warningAlertService,eventStream,parseOptions,addToOther,authtokenService,$filter,$interval,cleanObj,$timeout,API_URL, postDataService,$http,$attrs,$rootScope,$scope,getDataService,jQuery,$state,refreshtokenService, config, activeClass, alertService,putDataService,$window,serverError,cleanArray, checkArray, keyPressOnlyNumber, offlineError) {
    var vmp = this;
    var parent = $scope.$eval($attrs.parent);
    vmp.myPost = $scope.$eval($attrs.myPost);
    var appState = 'allposts'
    if(vmp.myPost) {
      appState = 'myposts'
    }
    var streamTaxonomy = 'posts';
    vmp.autosaveInterval;
    var tagPosts = null;
    var sponsored = null;
    vmp.recommendedNews = [];
    vmp.recommendedNewsShow = false;
    vmp.intervalHeartBeatFunction;
    vmp.newPost = true;
    vmp.postId = false;
    vmp.hasFeaturedImage = false;
    vmp.config = config;
    vmp.editurl = false;
    vmp.setFeaturedImageShow = false;
    vmp.selectedPostStatus={value:''}
    vmp.selectedPictureDemonstrate={value:'yes'};
    vmp.selectedDateDemonstrate={value:'yes'};
    // vmp.selectedRelatedDemonstrate={value:'no'};
    // vmp.selectedRelatedDemonstratePositionBottom = {value:'no'}
    vmp.selectedBannerDemonstrate={value:'yes'};
    vmp.selectedPrDemonstrate={value: 'no'};
    vmp.selectedPostMont = {value: "1"};
    vmp.featured_img = undefined;
    vmp.changeImageTrue = false;
    vmp.insertMediatoEditor = false;
    vmp.mediaModal = false;
    vmp.setFeaturedImage = false;
    vmp.cropModalShow = false;
    vmp.insertMediatoEditor = false;
    vmp.hiddenResult = -1;
    vmp.hasResult = true;
    vmp.editPostStatusShow = false;
    vmp.newTagRequired = false;
    vmp.allowcomments = true;
    vmp.titleRequired = false;
    vmp.categoryRequired = false;
    vmp.scheduledPost = false;
    vmp.category = null;
    vmp.tnow_data = null;
    vmp.titleNews = {};
    vmp.shortTitleNews = {};
    vmp.featured_img_id;
    vmp.statusDraft = true;
    vmp.dataPost = {};
    vmp.dataPost.tags = [];
    vmp.editorPreviewVisual = true;
    vmp.intervalHeartBeatPost = null;
    vmp.mediaLibrary = true;
    vmp.singleView = true;
    vmp.copyEditedSlug = false;
    vmp.categorychecked = {};
    vmp.parentCategoriesChecked = {};
    vmp.commentsPriority ={value:'0'}
    vmp.userId = parseInt(authtokenService.getUserId());
    vmp.aitoolsEnabled = authtokenService.getAitools();
    vmp.aiToolsObj = null;
    
    // Add change detection variables
    vmp.originalPostData = null;
    vmp.hasUnsavedChanges = false;
    vmp.isNavigatingAway = false;
    if(vmp.intervalHeartBeatPost) {
      $interval.cancel(vmp.intervalHeartBeatPost);
      vmp.intervalHeartBeatPost = null;
    }
    if(vmp.autosaveInterval) {
      $interval.cancel(vmp.autosaveInterval);
      vmp.autosaveInterval = null;
    }
    vmp.editPostDateShow = false;
    $rootScope.modalShow = false;
    vmp.editSlugShow = false; 
    var userId = authtokenService.getUserId();
    vmp.featuredImageRequired = false;
    vmp.revisionsModalShow = false;
    var updateDate = null;
    vmp.copySlug = null;
    vmp.data_grid = [];
    vmp.pastPost = false;
    vmp.searchPage = 0;
    vmp.postResult = [];
    vmp.selectedPhotoQuality={value:'medium'};
    vmp.slideShowUnsafe = false;
    vmp.keyPressOnlyNumber = keyPressOnlyNumber;
    vmp.focusTitle = false;
    vmp.titleSpellInorect = false;
    vmp.allAuthors = [];
    vmp.assignedPost = false;
    vmp.dataPost.keywords = []
    jQuery(document).on('click','.upload-image',function() {
      $scope.$apply(function() {
        vmp.mediaLibrary = true;
      })
    });
    vmp.openAiModal = function(funcionality, edit) {
      if(vmp.editorCharacterCount > 0) {
        vmp.showAiModal = true;
        vmp.aiToolsObj = vmp.config.aiTools.find(function(tool) {
          return tool.funcionality === funcionality;
        });
        if(edit) {
          vmp.aiToolsObj.edit = true;
        } else {
          vmp.aiToolsObj.edit = false;
        }
      } else {
        alertService('danger','Opps! ', 'Please write something in the editor before using AI.');
      }

    }
    vmp.updateAiResult = function(funcionality, selectedSuggestion) {
      if(selectedSuggestion.length == 0) return;
      if(funcionality == 'title-suggestion') {
        vmp.dataPost.title = selectedSuggestion;
      } else if(funcionality == 'tags-suggestion') {
        selectedSuggestion.forEach(function(tag){
          if(!tag.exists) {
            saveNewTag(tag.name);
          }
          if (!vmp.dataPost.tags.includes(tag._id)) {
            vmp.dataPost.tags.push(tag._id);
          }
        });
      } else if(funcionality == 'page-title-suggestion') {
        vmp.dataPost.page_title = selectedSuggestion;
      }else if(funcionality == 'text-summary') {
        // Check if there's an existing summary in the content
        if (vmp.tinymceModel && vmp.tinymceModel.includes('<summaryblock>')) {
            // Replace existing summary
            vmp.tinymceModel = vmp.tinymceModel.replace(/<summaryblock>[\s\S]*?<\/summaryblock>/, '<summaryblock>' + selectedSuggestion + '</summaryblock>');
        } else {
            // Add new summary at the beginning
            vmp.tinymceModel = '<summaryblock>' + selectedSuggestion + '</summaryblock>' + (vmp.tinymceModel || '');
        }
      } else if(funcionality == 'text-correction' || funcionality == 'text-reformulation' || funcionality == 'text-expansion') {
        if(vmp.tinymceModel && vmp.tinymceModel.includes('<summaryblock>')) { 
          var summaryMatch = vmp.tinymceModel.match(/<summaryblock>([\s\S]*?)<\/summaryblock>/);
          if(summaryMatch && summaryMatch[1]) {
              var summaryContent = summaryMatch[1];
              // Keep summary block and apply correction to rest of content
              vmp.tinymceModel = '<summaryblock>' + summaryContent + '</summaryblock>' + selectedSuggestion;
          }
        } else {
          vmp.tinymceModel = selectedSuggestion;
        }
      }
    }
    // vmp.assignToFunc = function() {
    //   var putFunction = function() {
    //     $http.put(API_URL + 'posts/reassign/' + vmp.postId, {'author':vmp.assignTo.value})
    //     .success(function (data, status, headers) {
    //       if(data.post) {
    //         if(data.post.writers) {
    //           console.log('usao')
    //           vmp.dataPost.writers = data.post.writers
    //           vmp.writers = vmp.dataPost.writers
    //         }
    //         if(data.post.author) {
    //           console.log('usao')
    //           vmp.dataPost.author = data.post.author
    //           vmp.assignTo = {value:vmp.dataPost.author.toString()};
    //         }
    //       }
    //       alertService('success','Success ', data.message, 2000);
    //     })
    //     .error(function (data, status, header, config) {
    //       if(!window.navigator.onLine) {
    //         offlineError()
    //         alertService('danger','Opps! ', 'Please check your internet connection and try again.');
    //         return
    //       }
    //       if(status ==401) {
    //         var promise = refreshtokenService.getAccessToken();
    //         promise.then(
    //           function(answer) {
    //             if(answer==200) {   
    //               putFunction();
    //             }
    //           },
    //           function(error) {
    //             // report something
    //           },
    //           function(progress) {
    //            // report progress
    //         });
    //       }else if(status ==502) {
    //         serverError();
    //       } else {  
    //         alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
    //       }
    //     });
    //   }
    //   putFunction();
    // }
    var getImageFunction = function(postId) {
      getDataService.get({param1:'attachments', param2: postId}).$promise.then(function(data){
        vmp.hasFeaturedImage = true;
        vmp.featured_img_obj = data; 
        vmp.featured_img_id = data._id;
         $rootScope.hasLoaded = true;
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                getImageFunction(postId);
              }
            },
            function(error) {
              // report something
            },
            function(progress) {
              // report progress
          });
        }else if(error.status ==502) {
              serverError();
        } else {
          $rootScope.hasLoaded = true;
        }
      }); 
    }
    
    function changeMediaStatus(postId, param) {
      if(!postId) return;
      $rootScope.hasLoaded = false;
      postDataService.save({
        param1:'attachments',
        param2:'status',
        param3:param
      },{
        'ids': [postId],
      }).$promise.then(function(data){
        getImageFunction(postId);
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                changeMediaStatus(postId,param);
              }
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
          });
        } else if(error.status ==502) {
          serverError()
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
        $rootScope.hasLoaded = true;
      });
    }
    vmp.changeMediaStatus = function(postId,param) {
      changeMediaStatus(postId, param)
    } 
    vmp.focusOutTitle = function(value) {

      vmp.spelledTitle = value;
      if(value) {
       var postFunction = function() {   
          postDataService.save({
            param1:'posts',
            param2:'spellcheck' 
          },{
            'title':value
          }).$promise.then(function(postData){
            if(!postData.bool) {
              vmp.spelledArray = postData.misspelledWords; 
              // var array = vmp.spelledTitle.split(" ");
              // postData.incorectWords.forEach(function(a){ 
              //   var index = array.indexOf(a);
              //   if(index !==-1) {
              //     array[index] = "<span class='highlight-error'>"+a+"</span>";
              //   }
              // });
              // vmp.spelledTitle = array.join(" ");
              vmp.titleSpellInCorect = true;
            } else {
              vmp.titleSpellInCorect = false;
            }
            // alertService('success','Success ', postData.message, 2000);
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError()
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    postFunction();
                  }
                },
                function(error) {
                  // report something
                },
                function(progress) {
                 // report progress
              });
            }else if(error.status ==502) {
              serverError();
            }else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            }
          });
        }
        postFunction();
        // replace each keyword in r with a mark'd replacement:
      }
    }
    vmp.openDictionaryModal = function(word) {
      vmp.misspelledWord = word;
      if(word) {
        vmp.dictionaryModalShow = true;
        $rootScope.modalShow = true;
      }
    }
    vmp.closeDictionaryModal = function() {
      $rootScope.modalShow = false;
      vmp.dictionaryModalShow = false;
      vmp.misspelledWord = undefined;
    }
    vmp.focusInTitle = function(value) {
      vmp.titleSpellInCorect = false;
    }
    vmp.addToOther = addToOther
    vmp.saveAttachments = function() {
      $scope.$broadcast('attachment-save');
    }
    vmp.permissionsOwnPost = true;
    vmp.permisions = true;
    if($rootScope.role_id == 'author-junior') {
      vmp.permisions = false;
      vmp.permissionsOwnPost = false;
    }
    var parseOptionsFunc = parseOptions
    var publishPostFunction = function(url, state, status,previewType) {
      var validatePublish = true;
      
      var putFunction = function() {
        if(status=='publish') {
          vmp.dataPost.status = 'publish'
          if(vmp.scheduledPost) {
            vmp.dataPost.status = 'schedule';
          }
        } else if(status=='trash') {
          vmp.dataPost.status = 'trash'
        } else {
          if(vmp.scheduledPost && state=='save') {
            if(vmp.editScheduledPost) {
              updateDate = moment().toISOString()
            } else {
              vmp.dataPost.status = 'schedule';
            }
          }
        }
        // if(vmp.relatedNews.length == 1) {
        //   if(!vmp.titleNews[0]) {
        //     recommended = null;
        //   } else {
        //     recommended = vmp.relatedNews;
        //     recommended[0].short_title = vmp.shortTitleNews[0];
        //   }
        // } else {
        //   for(var i=0; i<vmp.relatedNews.length; i++) {
        //     if(vmp.relatedNews[i].id && vmp.titleNews[i]) {
        //       vmp.relatedNews[i].short_title = vmp.shortTitleNews[i];
        //       recommended.push(vmp.relatedNews[i]);
        //     }
        //   }
        // }
        console.log(vmp.content);
        var updateDataPost = {
          "title": (vmp.dataPost.title)? (vmp.dataPost.title).replace(/\r?\n|\r/g, ' '): '',
          "page_title": (vmp.dataPost.page_title)? (vmp.dataPost.page_title).replace(/\r?\n|\r/g, ' '): '',
          "subtitle": (vmp.dataPost.subtitle)? (vmp.dataPost.subtitle).replace(/\r?\n|\r/g, ' '): '',
          "content": vmp.content,
          "category": vmp.category,
          "tags": tagPosts,
          // "slug": vmp.postSlug,
          // "image": vmp.featured_img_id,
          "status": vmp.dataPost.status,
          "comment_status": vmp.allowCommentsStatus,
          "comments_priority": parseInt(vmp.commentsPriority.value),
          "moderator_guide": vmp.dataPost.moderator_guide,
          "order": (vmp.dataPost.order)? parseInt(vmp.dataPost.order):undefined,
          "fixed_position": (vmp.dataPost.fixed_position)? parseInt(vmp.dataPost.fixed_position):undefined,
          "date": updateDate,
          "meta": {
            "options": {
              "display_feature_image": vmp.pictureDemonstrate,
              "display_update_time": vmp.dateDemonstrate,
              "display_intext_banner": vmp.inBannerDemonstrate,
              // "display_horizontal_block": vmp.relatedDemonstrate,
              // "display_horizontal_block_position_bottom": vmp.relatedDemonstratePositionBottom,
              "facebook_custom_title": vmp.facebookTitle,
              // "push_title":vmp.pushNotificationTitle,
              // "push_supertitle":vmp.pushNotificationSuperTitle,
              "mobile_title":vmp.mobileTitle,
              "display_photo": vmp.photoBadge,
              "display_video":vmp.videoBadge,
              "display_live":vmp.liveBadge,
              "by_comtrade":vmp.displayByComtrade,
              "copyright":vmp.copyright
            },
            'custom_shares':(vmp.dataPost.meta.custom_shares)? parseInt(vmp.dataPost.meta.custom_shares): undefined,
            "sponsored":sponsored,
            "recommended": vmp.recommendedNews,
            "tnow_video_data" : vmp.tnow_data
          },
          "writers":writers,
          // "display_writers":vmp.displayWriters,
          "display_writer_initials":vmp.displayWriterInitials,
          "display_writers":true,
          "preview_hash":vmp.previewHash,
          "videos": (vmp.featuredVideoObj)? [vmp.featuredVideoObj._id]:[],
          "liveblog":(vmp.dataPost.liveblog)? true:false,
          "editor_character_count":vmp.editorCharacterCount,
          "keywords":vmp.dataPost.keywords
        }
        if(state != 'save') {
          updateDataPost.slug = vmp.copySlug;
          if(!updateDataPost.slug) {
            updateDataPost.slug = ''
          }
        } else {
          if( vmp.postSlug != vmp.copySlug) {
            updateDataPost.slug = vmp.postSlug;
            if(!updateDataPost.slug) {
							updateDataPost.slug = ''
						}
            updateDataPost.meta.autoslug = 'false';
          }
        }
        cleanObj.clean(updateDataPost);
        cleanObj.clean(updateDataPost.meta);
        cleanObj.clean(updateDataPost.meta.options);
        updateDataPost.image = vmp.featured_img_id || null;
        updateDataPost.share_image =(vmp.shareImageObj && vmp.shareImageObj._id)?vmp.shareImageObj._id:null 
        updateDataPost.description_text = vmp.description_text;
        updateDataPost.description_custom = vmp.description_custom;
        updateDataPost.recommended_poll = (vmp.recommendedPollObj)? vmp.recommendedPollObj._id:null;
        var updateFunction = function() {
          // recommended = [];
          $http.put(url , updateDataPost)
          .success(function (data, stat, headers) {
            if(!vmp.singleView) return;
            if(!window.navigator.onLine) {
              offlineError()
              return
            }
            updateDataPost = {};
            $rootScope.hasLoaded = true;
            // recommended = [];
            if(state=="save") {
              // Clear unsaved changes flag when post is successfully saved
              if (vmp.newPost) {
                vmp.hasUnsavedChanges = false;
                vmp.isNavigatingAway =  true;
              }
              
              if(status=='trash') {
                parent.editPostShow = false;
                $state.transitionTo('app.'+appState, {id: null}, {
                  location: true,
                  inherit: true,
                  relative: $state.$current,
                  notify: false
                });
                alertService('success','Success ', data.message, 2000);
              } else {
                alertService('success','Success ', data.message, 2000);
                if(vmp.newPost) {
                  $timeout(function() {
                    $state.go('app.allposts',{id:vmp.postId});
                  },1000);
                } else {
                  getCategoriesFunction('save');
                }
              }
            } else if(state=="preview") {
              if(previewType) {
                // if(vmp.editPublish) {
                //   if(previewType == 'app' && vmp.dataPost.mobile_url) {
                //     vmp.initQrCodeFunction(vmp.dataPost.mobile_url)
                //   } else if(previewType == 'web'){
                //     vmp.initQrCodeFunction(vmp.dataPost.url);
                //   }
                // } else {
                //   if(previewType == 'app' && vmp.dataPost.preview_mobile) {
                //     vmp.initQrCodeFunction(vmp.dataPost.preview_mobile + '&ts=' + Date.now())
                //   } else if(previewType == 'web' && vmp.dataPost.preview){
                //      vmp.initQrCodeFunction(vmp.dataPost.preview + '&ts=' + Date.now())
                //   }
                // }
              } else {
                if(vmp.editPublish) {
                  if(status=='preview') {
                    $window.open(vmp.dataPost.preview + '&ts=' + Date.now(), '_preview');  
                  }else {
                    $window.open(vmp.dataPost.url, '_view');
                  }
                } else {
                  $window.open(vmp.dataPost.preview + '&ts=' + Date.now(), '_preview');
                }
              }
            }
          })
          .error(function (data, status, header, config) {
            if(status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    updateFunction();
                  }
                },
                function(error) {
                },
                function(progress) {
                  // report progress
              });
            }else if(status ==502) {
              if(state=="save") {
                serverError()  
              }
            } else {
              if(state=="save" && ($state.is('app.newpost') || vmp.singleView)) {
                if(!window.navigator.onLine) {
                  offlineError()
                  alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                } else {
                  alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
                }
                vmp.intervalHeartBeatFunction();
                if(!vmp.intervalHeartBeatPost) {
                  vmp.intervalHeartBeatPost = $interval(vmp.intervalHeartBeatFunction,vmp.config.heartbeat.pulse*1000);
                }
                if(!vmp.autosaveInterval) {
                  vmp.autosaveInterval = $interval(vmp.autoSaveFunction,vmp.config.heartbeat.autosave*1000);
                }
              }
            }
            updateDataPost = {};
            // recommended = [];
            $rootScope.hasLoaded = true;
          });
        }
        updateFunction();
      }
      if(vmp.allowcomments) {
        vmp.allowCommentsStatus = 'open';
      } else {
        vmp.allowCommentsStatus = 'closed';
      }
      if(vmp.selectedPictureDemonstrate.value == 'yes') {
        vmp.pictureDemonstrate = true;
      } else {
        vmp.pictureDemonstrate = false;
      }
      if(vmp.selectedDateDemonstrate.value == 'yes') {
        vmp.dateDemonstrate = true;
      } else {
        vmp.dateDemonstrate = false;
      }
      if( vmp.selectedBannerDemonstrate.value=='yes') {
        vmp.inBannerDemonstrate = true;
      } else {
        vmp.inBannerDemonstrate = false;
      }
      if(vmp.selectedPrDemonstrate.value== 'yes') {
        vmp.prDemonstrate = true;
      } else {
        vmp.prDemonstrate = false;
      }
      // if(vmp.selectedRelatedDemonstrate.value=='yes') {
      //   vmp.relatedDemonstrate = true
      // } else {
      //   vmp.relatedDemonstrate = false
      // }
      // if(vmp.selectedRelatedDemonstratePositionBottom.value=='yes') {
      //   vmp.relatedDemonstratePositionBottom = true
      //   vmp.relatedDemonstrate = true
      // } else {
      //   vmp.relatedDemonstratePositionBottom = false
      // }
      // if(!vmp.pushNotificationTitle) {
      //   vmp.pushNotificationTitle = null
      // }
      // if(!vmp.pushNotificationSuperTitle) {
      //   vmp.pushNotificationSuperTitle = null
      // }
      if(!vmp.facebookTitle) {
        vmp.facebookTitle = null
      }
      var writers = [];
      if(vmp.writers.length>0) {
        for(var i=0;i<vmp.writers.length;i++) {
          writers.push(vmp.writers[i]['_id'])
        }
      }
      if(vmp.dataPost.tags) {
        if(vmp.dataPost.tags.length==0) {
          tagPosts = null;
        }else {
          tagPosts = vmp.dataPost.tags;
        }
      }
      sponsored = {
        "display": vmp.prDemonstrate,
         "title": vmp.prTextTitle
      }
      if(!sponsored.display) {
        sponsored = null
      }
      vmp.content = vmp.textEditorContent; 
      if(state=="save") {
        if(vmp.dataPost.title) {
          vmp.titleRequired = false;
        } else {
          vmp.titleRequired = true;
          alertService('danger','Opps! ', 'Title is required');
          validatePublish = false;
        }
        if(vmp.titleExceed && vmp.dataPost.title.length>110 && status != 'trash') {
          validatePublish = false;
          alertService('danger','Opps! ', 'Maximum number of characters in title is 110');
        } 
        // if(vmp.dataPost.page_title) {
        //   vmp.pageTitleRequired = false;
        // } else {
        //   vmp.pageTitleRequired = true;
        //   alertService('danger','Opps! ', 'Page title is required');
        //   validatePublish = false;
        // }
        // if(vmp.dataPost.subtitle) {
        //   vmp.subtitleRequired = false;
        // } else {
        //   vmp.subtitleRequired = true;
        //   validatePublish = false;
        // }
       // console.log(vmp.editPublish);
       // console.log(vmp.editPublish);
        if(!updateDate) {
          updateDate = moment().toISOString();
        }
        // if(!vmp.editPublish && !vmp.scheduledPost && vmp.dataPost.status=='publish') {
        //   updateDate = moment().toISOString();
        // }
        // if()
        if(vmp.editSlugShow) {
          validatePublish = false;
          alertService('danger','Opps! ', 'Cancel or edit permalink');
        }
        if(vmp.category) {
          vmp.categoryRequired = false;
          if(status=="publish" && vmp.category == 'uncategorized') {
            vmp.categoryRequired = true;
            alertService('danger','Opps! ', 'To publish a post, you must select a category other than "Uncategorized".')
            validatePublish = false;
          }
        } else {
          vmp.categoryRequired = true;
          alertService('danger','Opps! ', 'Category is required')
          validatePublish = false;
        }
        if(status =='publish' || (vmp.scheduledPost && status != 'trash')) {
          if(vmp.featured_img_id) {
            vmp.featuredImageRequired = false
          } else {
            alertService('danger','Opps! ', 'Featured image is required')
            vmp.featuredImageRequired = true;
            validatePublish = false;
          }
        }
        if(vmp.displayWriters && vmp.writers.length==0) {
          vmp.writersRequired = true;
          alertService('danger','Opps! ', 'Author is required')
          validatePublish = false;
        } else {
          vmp.writersRequired = false;
        }
        if(vmp.dataPost.fixed_position) {
          if(parseInt(vmp.dataPost.fixed_position)<=10 &&  parseInt(vmp.dataPost.fixed_position)>=0) {
            vmp.fixedPositionValidate = false;
          } else {
            alertService('danger','Opps! ', 'Fixed position must be in range 0-10')
            vmp.fixedPositionValidate = true;
            validatePublish = false;
          }
        }   
        if(validatePublish) {
          $rootScope.hasLoaded = false;
          vmp.featuredImageRequired = false;
          if(vmp.autosaveInterval) {
            $interval.cancel(vmp.autosaveInterval);
            vmp.autosaveInterval = null;
          }
          if(vmp.intervalHeartBeatPost) {
            $interval.cancel(vmp.intervalHeartBeatPost);
            vmp.intervalHeartBeatPost = null;
          }
          vmp.autoSaveFunction();
          putFunction();
        }
        
      }else if(state=="preview") {
        if(vmp.dataPost.title) {
          vmp.titleRequired = false;
        } else {
          vmp.titleRequired = true;
          alertService('danger','Opps! ', 'Title is required');
          validatePublish = false;
        }
        // if(vmp.dataPost.page_title) {
        //   vmp.pageTitleRequired = false;
        // } else {
        //   vmp.pageTitleRequired = true;
        //   alertService('danger','Opps! ', 'Page title is required');
        //   validatePublish = false;
        // }
        if(vmp.category) {
          vmp.categoryRequired = false;
        } else {
          vmp.categoryRequired = true;
          alertService('danger','Opps! ', 'Category is required')
          validatePublish = false;
        }
        if(validatePublish) {
          putFunction();
        }
      } else {
        putFunction();
      }
    }
    // vmp.qrLoad = false;
    // vmp.qrLoaded = false;
    // var canvas = document.getElementById('canvas-qr')
    // vmp.changePreviewQrCode = function(event, type) {
    //   vmp.qrLoad = true;
    //   vmp.qrLoaded = false;
    //   activeClass.active(event)
    //   if(!vmp.singleView) return; 
    //   publishPostFunction(API_URL+ "posts/"+vmp.postId+"/?autosave=true", "preview", undefined, type);
    // }
    // vmp.initQrCodeFunction = function(url) {
    //   QRCode.toCanvas(canvas, url,{width:250,height:250}, function (error) {
    //     if (error) console.error(error)
    //     console.log('qrcode success!')
    //       vmp.qrLoaded = true;
    //   })
    // }
    vmp.previewPost = function(preview) {
      if(!vmp.singleView) return; 
      publishPostFunction(API_URL+ "posts/"+vmp.postId+"/?autosave=true", "preview", preview);
    }
    vmp.autoSaveFunction = function() {
        if(!vmp.singleView || !vmp.dataPost) return;
        publishPostFunction(API_URL+ "posts/"+vmp.postId+"/?autosave=true", undefined,undefined);
    }
    

    vmp.publishPost = function() {
      vmp.titleSpellInCorect = false;
      publishPostFunction(API_URL+ "posts/"+vmp.postId, 'save', 'publish');
    }
    vmp.trashPost = function() {
      publishPostFunction(API_URL+ "posts/"+vmp.postId, 'save', 'trash');
    }
    vmp.updateorSavePost =  function() {
      vmp.titleSpellInCorect = false;
      if(vmp.dataPost.status == 'publish') {
        publishPostFunction(API_URL+ "posts/"+vmp.postId, 'save', 'publish')
      } else {
        publishPostFunction(API_URL+ "posts/"+vmp.postId, 'save', undefined);
      }
    }
    if($rootScope.mediaComunicateWithEditPost) {
      parent.editPostShow = true;
      vmp.postId = $rootScope.mediaComunicateWithEditPost;
    }
    function takeoverCallback(data) {
      $scope.$apply(function() {
        if(data.item_id == vmp.postId && data.type =='post_force_unlocked' && data.locked_session_id != tabSessionService.getSessionId()) {
          takeOverPostFunc(data.message);
        }
      });
    }
    if(!eventStream.getConnection(streamTaxonomy)) {
      eventStream.connect(streamTaxonomy,vmp.config.lockingManager[streamTaxonomy]);
    }
    if(!eventStream.hasMessageHandler(streamTaxonomy,takeoverCallback)) {
      eventStream.onMessage(streamTaxonomy,takeoverCallback);
    }
    if(parent) {
      // if(parent.intervalHeartBeat) {
      //   $interval.cancel(parent.intervalHeartBeat);
      //   parent.intervalHeartBeat = null;
      // }
      vmp.postId = parent.post_id;
    }
    vmp.intervalHeartBeatFunction = function() {
      if(!vmp || !vmp.singleView) return;
      var intervalFunction = function() {
        if($state.is('app.allposts') || $state.is('app.newpost') || $state.is('app.myposts') ) {
          putDataService.update({
            param1:'posts', 
            param2: 'heartbeat',
            param3: vmp.postId
          }).$promise.then(function(data){
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError(vmp.intervalHeartBeatFunction)
              return
            }
            if(error.status == 401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
              function(answer) {
                if(answer==200) {  
                  intervalFunction();
                }
                // do something
              },
              function(error) {
                // report something
              },
              function(progress) {
                // report progress
              });
            } else if(error.status == 403 || error.status == 423) {
              takeOverPostFunc(error.data.error.message);
            }
          });
        }
      }
      intervalFunction();
    }
    function takeOverPostFunc(message) {
      $timeout(function() {
        $rootScope.closeEditPost();
        alertService('info','Notice! ', message)
      },0);
      if(vmp.autosaveInterval) {
        $interval.cancel(vmp.autosaveInterval);
        vmp.autosaveInterval = null;
      }
      if(vmp.intervalHeartBeatPost) {
        $interval.cancel(vmp.intervalHeartBeatPost);
        vmp.intervalHeartBeatPost = null;
      }
    }
    var addNewTagFunction = function(data) {
      vmp.newTagRequired = false;
      if(!checkArray.contains.call(vmp.dataPost.tags,data.tagId)) {
        vmp.dataPost.tags.push(data.tagId);
        vmp.searchtagfocus = null;
        vmp.existTag = false;
      } else {
        vmp.existTag = true;
      }
    }
    $scope.$on('select-tag', function(event,data) {
      addNewTagFunction(data.selectedTagObj)
    });
    function saveNewTag(newTag,callback) {
      postDataService.save({
        param1:'tags', 
        // param2: 'create'
      },{
        'name': newTag
      }).$promise.then(function(postTag){
        if(callback) {
          var data = {
            tagId:postTag.tag._id,
            tagname: postTag.tag.name
          } 
          callback(data);
        }
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {   
                saveNewTag(newTag,callback);
              }
            },
            function(error) {
            },
            function(progress) {
             // report progress
          });
        } else if(error.status ==502) {
          serverError()
        } else if(error.status ==400) {
          if(callback) {
            var data = {
              tagId:error.data.tag._id,
              tagname: error.data.tag.name
            } 
            callback(data);
          }
        }
      });
    } 
    vmp.addNewTag = function() {
      if(vmp.searchtagfocus && vmp.searchtagfocus.length>2) {
        saveNewTag(vmp.searchtagfocus,function(data){
          addNewTagFunction(data);
        });
      } else {
        vmp.newTagRequired = true;
      }
    }
    vmp.removeFromTagsList = function(index) {
      vmp.dataPost.tags.splice(index, 1);
    }
    vmp.editPostStatus = function() {
      vmp.editPostStatusShow = true;
    }
    vmp.editPostTime = function() {
      vmp.editPostDateShow = true;
      if(!vmp.pastPost &&!vmp.editPublish && !vmp.scheduledPost) {
        convertTimeFunction(undefined);
      } 
    }
    $scope.$on('live-badge',function(event,data){
      vmp.liveBadge = data.display;
      vmp.dataPost.liveblog = true
      event.stopPropagation()
    })
    vmp.changePostStatus = function() {
      vmp.editPostStatusShow = false;
      vmp.dataPost.status = vmp.selectedPostStatus.value;
    }
    vmp.cancelEditPostStatus = function() {
      vmp.editPostStatusShow = false;
      vmp.selectedPostStatus = {value: vmp.dataPost.status};
    }
    // vmp.relatedNews = [{'id': '', 'title': '','url':'','short_title':'','date':''}];
    // vmp.addNewNews = function() {
    //   if(vmp.relatedNews.length < 10) {
    //     vmp.relatedNews.push({'id': '', 'title': '','url':'','short_title':'','date':''});
    //   }
    // };
    // vmp.removeNews = function() {
    //   var lastItem = vmp.relatedNews.length-1;
    //   if (vmp.relatedNews.length>1) {
    //     vmp.relatedNews.splice(lastItem);
    //     vmp.titleNews[lastItem] =null;
    //     vmp.shortTitleNews[lastItem] = null;
    //   } 
    // };
    // angular.element(document).on('mousedown', function(e) {
    //   if(!vmp.singleView) return;
    //   if(angular.element(document.getElementsByClassName("autocomplete-result"))) {
    //     var container = angular.element(document.getElementsByClassName("autocomplete-result"));
    //     var serch_input = angular.element(document.getElementsByClassName("search-autocomplete"));
    //     if (!container.is(e.target) // if the target of the click isn't the container...
    //       && container.has(e.target).length === 0 && vmp.hiddenResult != -1 && !serch_input.is(e.target) && serch_input.has(e.target).length===0) // ... nor a descendant of the container
    //     {
    //       $scope.$apply(function () {
    //         vmp.hiddenResult = -1;
    //         vmp.postResult = [];
    //         vmp.searchPage = 0;
    //       });
    //     }
    //   }
    // });
    // vmp.searchPress = function(evt,star) {
    //   keyPress(evt,star);
    // }
    // vmp.readMore = function(searchData, index) {
    //   vmp.searchPage +=10;
    //   $timeout(function() {
    //     vmp.searchRelatedNews(searchData, index, 'loadMore');
    //   },0)
    // }
    // vmp.searchRelatedNews = function(searchData, index, loadMore) {
    //   var size=10;
    //   vmp.loadMore = false;
    //   if(loadMore!='loadMore') {
    //     vmp.searchPage = 0;
    //     vmp.postResult = [];
    //   }
    //   // vmp.hiddenResult = -1;
    //   if(searchData) {
    //     if(searchData.length >1) {
    //       var url = elasticSearch.getUrl(searchData);
    //       url = url + '&from='+ vmp.searchPage +'&size='+ size;
    //       $http({
    //         method: 'GET',
    //         url: url
    //       }).then(function successCallback(response) {
    //         if(!response.data) return;
    //         if(loadMore=='loadMore') {
    //           vmp.postResult = vmp.postResult.concat(response.data.hits.hits);
    //         } else {
    //           vmp.postResult = response.data.hits.hits;
    //         }
    //         vmp.hiddenResult = index;
    //           if(vmp.postResult.length > 0) {
    //             vmp.hasResult = true;
    //             vmp.loadMore = true;
    //           } else {
    //             vmp.hasResult = false;
    //           }
    //           if(response.data.hits.total >vmp.postResult.length) {
    //             vmp.loadMore = true;
    //           } else {
    //             vmp.loadMore = false;
    //           }
    //           vmp.chooseSearchData = function(post) {
    //             vmp.hiddenResult = -1;
    //             vmp.postResult = [];
    //             vmp.searchPage = 0;
    //             vmp.relatedNews[index].title = post._source.post_title;
    //             vmp.titleNews[index] = post._source.post_title;
    //             vmp.relatedNews[index].id = post._id;
    //             vmp.relatedNews[index].url = post._source.url;
    //             vmp.relatedNews[index].date = post._source.uts;
    //             vmp.relatedNews[index].image = post._source.image;
    //           };
    //           // this callback will be called asynchronously
    //           // when the response is available
    //       }, function errorCallback(response) {
    //         if(!window.navigator.onLine) {
    //           offlineError()
    //           vmp.hiddenResult = -1;
    //           return
    //         }
    //           // called asynchronously if an error occurs
    //           // or server returns response with an error status.
    //       });
    //     } else {
    //       vmp.hiddenResult = -1;
    //     } 
    //   } else {
    //     vmp.hiddenResult = -1;
    //   }
    // }
    vmp.editorChangePreviw = function(event, editorPreview) {
      activeClass.active(event);
      $scope.$broadcast("change-editor",{editor_preview:editorPreview});
      if(editorPreview == 'text') {
        vmp.editorPreviewVisual = false;
      } else {
        vmp.editorPreviewVisual = true;
      }    
    }
    $rootScope.$on("edit-image",function(event, data) {
      vmp.editImageObj = data.editImageObj;
      vmp.editImagefromEditor = true;
    });
    vmp.openRevisionsModal = function() {
      $rootScope.modalShow = true;
      vmp.revisionsModalShow = true;
    }
    vmp.cancelRevisionsModal = function() {
     $rootScope.modalShow = false;
      vmp.revisionsModalShow = false; 
    }
    vmp.openCropModal = function() {
      vmp.cropModalShow = true;
      $rootScope.modalShow = true;
    }
    vmp.cancelCropModal = function() {
      vmp.cropModalShow = false;
      $rootScope.modalShow = false;
    }
    vmp.addMediatoEditor = function() {
      vmp.mediaModal = true;
      vmp.insertMediatoEditor = true;
      vmp.galleryInPhoto = true;
      $rootScope.modalShow = true;
    }
    vmp.addGallerytoEditor = function(update) {
      vmp.mediaModal = true;
      vmp.insertGallery = true;
      $rootScope.modalShow = true;
      if(update) {
        vmp.updateGallery = true;
      }
    }
    vmp.insertVideotoEditor = function() {
      $rootScope.modalShow = true;
      vmp.videoModalShow = true;
      vmp.insertVideoToEditorModal = true;
    }
    vmp.cancelVideoModal = function() {
      $rootScope.modalShow = false;
      vmp.videoModalShow = false;
      vmp.setFeaturedVideoModal = false;
      vmp.insertVideoToEditorModal = false;
    }
    vmp.openSetFeaturedImage = function() {
      vmp.mediaModal = true;
      vmp.setFeaturedImage = true;
      $rootScope.modalShow = true;
    };
    vmp.openSetShareImage = function() {
      vmp.mediaModal = true;
      $rootScope.modalShow = true;
      vmp.setShareImage = true;
    }
    vmp.cancelImageModal = function() {
      $rootScope.modalShow = false;
      vmp.mediaModal = false;
      vmp.editImagefromEditor = false;
      vmp.setFeaturedImage = false;
      vmp.insertMediatoEditor = false;
      vmp.insertGallery = false;
      vmp.updateGallery = false;
      vmp.gallery_title = '';
      vmp.slideShowUnsafe = false;
      vmp.galleryUpdateIds = '';
      vmp.galleryInPhoto = false;
      vmp.setShareImage = false;
    }
    $scope.addPollToEditor = function() {
      vmp.addPollToEditorShow= true;
      vmp.pollResultDisplay = true
      vmp.pollModalShow=true;
      $rootScope.modalShow = true;
    }
    $scope.addRatingToEditor = function() {
      vmp.addRatingToEditorShow= true;
      vmp.ratingResultDisplay = true;
      vmp.ratingModalShow=true;
      $rootScope.modalShow = true;
    }
    vmp.addRecommendedPoll = function() {
      vmp.addPollToRecomended = true;
      vmp.pollResultDisplay = false;
      vmp.pollModalShow=true;
      $rootScope.modalShow = true;
    }
    vmp.setRecommnededPoll = function(pollObj) {
      vmp.recommendedPollObj = pollObj;
    }
    vmp.removeRecommendedPoll = function() {
      vmp.recommendedPollObj = null;
    }
    vmp.cancelPollModal = function(){
      vmp.pollModalShow=false;
      $rootScope.modalShow = false;
      vmp.addPollToEditorShow= false;
      vmp.addPollToRecomended = false;
    }
    vmp.cancelRatingModal = function(){
      vmp.ratingModalShow=false;
      $rootScope.modalShow = false;
      vmp.addRatingToEditorShow= false;
    }
    $scope.addBlogToEditor = function() {
      vmp.blogModalShow=true;
      vmp.addBlogToEditorShow= true;
      $rootScope.modalShow = true;
    }
    vmp.cancelBlogModal = function(){
      vmp.blogModalShow=false;
      $rootScope.modalShow = false;
      vmp.addBlogToEditorShow= false;
    }
    $scope.$watchCollection(function(){
        return vmp.changeImageTrue
      }, function(newValue, oldValue){
        if (newValue) {
          $scope.$broadcast("change-image",{afterImage:true});
        }
      },true);
    vmp.editSlug = function(slug) {
      vmp.copyEditedSlug = angular.copy(slug);
      vmp.editSlugShow = true;
    }
    vmp.cancelSlug = function() {
      vmp.postSlug = vmp.copyEditedSlug;
      if(!vmp.postSlug) {
				vmp.postSlug = '';
			} 
      vmp.editSlugShow = false; 
    }
    vmp.updateSlug = function() {
      vmp.postSlug = slugify(vmp.postSlug)
      if(!vmp.postSlug) {
				vmp.postSlug = '';
			} 
      vmp.editSlugShow = false; 
    }
    vmp.removeFeaturedImage = function() {
      vmp.hasFeaturedImage = false;
      vmp.featured_img_obj = undefined;
      vmp.featured_img_id = undefined;
    }
    vmp.removeShareImage = function() {
      vmp.shareImageObj = null;
    }
    vmp.cancelEditPostDate = function() {
      vmp.editPostDateShow = false; 
    }
    
    vmp.setPublishedDate = function() {
      vmp.editPostDateShow = false; 
      // vmp.scheduledPost = false;
      var dateArray = [vmp.postYear, parseInt(vmp.selectedPostMont.value)-1, vmp.postDay, vmp.postHours, vmp.postMinutes];
      updateDate = moment(dateArray).toISOString();
      if(moment.duration(moment(dateArray).diff(moment())).asMinutes()>5) {
        vmp.scheduledPost = true;
      } else if(moment.duration(moment(dateArray).diff(moment())).asMinutes()<=5 && moment.duration(moment(dateArray).diff(moment())).asMinutes()>-5 && !vmp.editPublish) {
          updateDate = moment().toISOString();
          vmp.scheduledPost = false;
          vmp.pastPost = false;
      }
      else {
          vmp.pastPost = true;
          vmp.scheduledPost = false;
      }
      vmp.dataPost.date = $filter('date')(updateDate, "MMM d, y HH:mm");
    }
    var convertTimeFunction = function(date) {
      var a = moment(date);
      var year = a.format('YYYY');
      var month = a.format('M');
      var day = a.format('D');
      var hour = a.hours();
      var min = a.minutes();
      var sec = a.seconds();
      vmp.postYear = year;
      vmp.selectedPostMont = {value: month};
      vmp.postDay = day;
      if(hour<10) {
        vmp.postHours = '0'+hour;  
      } else {
        vmp.postHours = hour;
      }
      if(min<10) {
        vmp.postMinutes = '0'+min;  
      } else {
        vmp.postMinutes = min;
      }
    } 
    $scope.$on('restore-post',function(event,data) {
      console.log(data);
      var postContent = data.post.content
      vmp.textEditorContent = data.post.content;
      if(postContent) {
        postContent.replace(/\[caption([^\]].*?)\]([^\]]*?)\[\/caption\]/g, function(all, attr, con) {
            var parseOptions = parseOptionsFunc(attr);
            if(parseOptions.signature_url) {
              var signatureUrl = parseOptions.signature_url
            } else {
              var signatureUrl = ''
            }
            if(parseOptions.image_link) {
              var imageLink = 'image_link="'+parseOptions.image_link+'"'
            } else {
              var imageLink = ''
            }
            if(parseOptions.image_target_blank) {
              var imageTargetBlank = 'image_target_blank="'+parseOptions.image_target_blank+'"'
            } else {
              var imageTargetBlank = ''
            }
            var imageLinkSummary = imageLink ? imageLink + (imageTargetBlank ? ' ' + imageTargetBlank : '') : '';
            postContent = postContent.replace( all,'<captionblock id="'+parseOptions.id+'" align="'+parseOptions.align+'" width="' +parseOptions.width +'" height="' +parseOptions.height +'" signature_url="'+ signatureUrl +'" '+imageLinkSummary+'>'+con+'</captionblock>');
        });
        postContent.replace(/\[gallery([^\]].*?)\]/g, function(all, attr) {
          var parseOptions = parseOptionsFunc(attr);
          postContent = postContent.replace( all,'<galleryblock ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' +parseOptions.title +'">[gallery ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' +parseOptions.title +'"]</galleryblock>');
        });
        postContent.replace(/\[embed\s+([^\]]*?)\]([\s\S]*?)\[\/embed\]/g, function(all, attr, con) {
          var parseOptions = parseOptionsFunc(attr);
          var type = parseOptions.type || parseOptions.src;
          postContent = postContent.replace( all,'<embedblock type="'+type+'">'+con+'</embedblock>');
        });
        postContent.replace(/\[summary\]([\s\S]*?)\[\/summary\]/g, function(all) {
            postContent = postContent.replace(all, '<summaryblock>' + all + '</summaryblock>');
        });
        postContent = wpautop(postContent);
        vmp.tinymceModel = postContent;
      }
      var author = data.post.author;
      var date = $filter('date')(data.post.date, "MMM d, y H:mm");
      vmp.dataPost.title = data.post.title;
      vmp.dataPost.subtitle = data.post.subtitle;
      alertService('success','Success ', 'Post successfully restored. Click on update to save post changes.', 7000);
    });
    function initializeFeaturedVideo(videoObj) {
      vmp.featuredVideoObj = videoObj;
      vmp.featuredVideoAdded =true;
      vmp.featuredVideoLoaded = false;
      if(!vmp.featuredVideoPlayer) {
        $timeout(function() {
          var posterDisplayRes = (vmp.featuredVideoObj.orientation == 'portrait')? '-360x640.jpg': '-300x170.jpg';
          vmp.featuredVideoPlayer = videojs('featured-video',
          {
            poster:vmp.config.baseVideoHref + vmp.featuredVideoObj.image.replace('.jpg', posterDisplayRes),  
            autoplay:false
          });
            setupVideo();  
        },0)
      } else {
        $timeout(function() {
          setupVideo();
          var posterDisplayRes = (vmp.featuredVideoObj.orientation == 'portrait')? '-360x640.jpg': '-300x170.jpg';
          vmp.featuredVideoPlayer.poster(vmp.config.baseVideoHref + vmp.featuredVideoObj.image.replace('.jpg', posterDisplayRes));
        },0)
      }
    }
    function setupVideo() {
      var video_file = vmp.config.baseVideoHref + vmp.featuredVideoObj.file.m3u8;
      if(vmp.featuredVideoObj.duration){
        var formatedTime;
        if(vmp.featuredVideoObj.duration>=3600) {
          formatedTime = 'H:mm:ss'
        } else {
          formatedTime = 'm:ss'
        } 
        vmp.featuredVideoObj.formated_duration = moment().startOf('day').second(vmp.featuredVideoObj.duration).format(formatedTime);
      }
      vmp.featuredVideoPlayer.src({
        src: video_file,
          type: 'application/x-mpegURL',
          withCredentials: false
      });
      vmp.featuredVideoPlayer.on("play", function() {
        $scope.$apply(function() {
          vmp.featuredVideoObjDurationFlag = false;
        })
      });
      vmp.featuredVideoLoaded = true;
      vmp.featuredVideoObjDurationFlag = true;
    }
    vmp.setFeaturedVideoFunction = function(videoObj) {
      if(!videoObj) return;
      initializeFeaturedVideo(videoObj);
    }
    vmp.disposeVideo = function() {
      if(vmp.featuredVideoPlayer) {
        vmp.featuredVideoPlayer.dispose();
        vmp.featuredVideoPlayer = null;
      }
    }
    vmp.setFeaturedVideo = function() {
      $rootScope.modalShow = true;
      vmp.setFeaturedVideoModal = true;
    }
    vmp.removeFeaturedVideo = function () {
      vmp.disposeVideo();
      vmp.featuredVideoObj = null;
      vmp.featuredVideoAdded =false;
    }
    vmp.editPostFunction = function() {
      updateDate = null;
      vmp.pastPost = false;
      vmp.scheduledPost = false;
      vmp.editScheduledPost = false;
      vmp.editPublish =false;
      vmp.postSlug = null;
      vmp.copySlug = null;
      vmp.previewHash = null;
      vmp.substringUri = null;
      vmp.mobileTitle = null;
      vmp.facebookTitle = null;
      // vmp.pushNotificationTitle = null;
      // vmp.pushNotificationSuperTitle = null;
      vmp.prTextTitle = null;
      vmp.tnow_data = null;
      vmp.hasFeaturedImage = false;
      vmp.featured_img_obj = undefined; 
      vmp.featured_img_id = undefined;
      vmp.shareImageObj = null;
      vmp.categoryIdOnLoad = undefined;
      if(vmp.dataPost.status == 'publish') {
        vmp.editPublish = true;
        if(vmp.dataPost.date) {
          updateDate = vmp.dataPost.date;
        }
      }else if(vmp.dataPost.status=='trash') {
        parent.editPostShow = false;
        if(vmp.autosaveInterval) {
          $interval.cancel(vmp.autosaveInterval);
          vmp.autosaveInterval = null;
        }
        if(vmp.intervalHeartBeatPost) {
          $interval.cancel(vmp.intervalHeartBeatPost);
          vmp.intervalHeartBeatPost = null;
        }
        $state.transitionTo('app.'+appState, {id: null}, {
          location: true,
          inherit: true,
          relative: $state.$current,
          notify: false
        });
      } else if(vmp.dataPost.status=='schedule') {
        vmp.scheduledPost = true;
        vmp.editScheduledPost = true;
        if(vmp.dataPost.date) {
          updateDate = vmp.dataPost.date;
        }
      }
      if(vmp.dataPost.status=='assigned') {
        vmp.assignedPost = true
      } else {
        vmp.assignedPost = false
      }
      if(vmp.dataPost.date) {
        vmp.dataPost.date = $filter('date')(vmp.dataPost.date, "MMM d, y HH:mm");
        convertTimeFunction(vmp.dataPost.date);
      }
      if('meta' in vmp.dataPost) {
        if('sponsored' in vmp.dataPost.meta) {
          if(vmp.dataPost.meta.sponsored.display == true) {
            vmp.selectedPrDemonstrate.value = 'yes'
          } else {
            vmp.selectedPrDemonstrate.value = 'no'
          }
          if('title' in vmp.dataPost.meta.sponsored) {
            vmp.prTextTitle = vmp.dataPost.meta.sponsored.title;
          }
        }
        if('options' in vmp.dataPost.meta) {
          if(vmp.dataPost.meta.options.display_feature_image == true) {
            vmp.selectedPictureDemonstrate.value = 'yes'
          } else {
            vmp.selectedPictureDemonstrate.value = 'no'
          }
          // if(vmp.dataPost.meta.options.display_horizontal_block == true) {
          //   vmp.selectedRelatedDemonstrate.value = 'yes'
          // } else {
          //   vmp.selectedRelatedDemonstrate.value = 'no'
          // }
          // if(vmp.dataPost.meta.options.display_horizontal_block_position_bottom == true) {
          //   vmp.selectedRelatedDemonstratePositionBottom.value = 'yes'
          // } else {
          //   vmp.selectedRelatedDemonstratePositionBottom.value = 'no'
          // }
          if(vmp.dataPost.meta.options.display_intext_banner == true) {
            vmp.selectedBannerDemonstrate.value = 'yes'
          } else {
            vmp.selectedBannerDemonstrate.value = 'no'
          }
          if(vmp.dataPost.meta.options.display_update_time == true) {
            vmp.selectedDateDemonstrate.value = 'yes'
          } else {
            vmp.selectedDateDemonstrate.value = 'no'
          } 
          if(vmp.dataPost.meta.options.facebook_custom_title) {
            vmp.facebookTitle = vmp.dataPost.meta.options.facebook_custom_title
          }
          // if(vmp.dataPost.meta.options.push_title) {
          //   vmp.pushNotificationTitle = vmp.dataPost.meta.options.push_title
          // }
          // if(vmp.dataPost.meta.options.push_supertitle) {
          //   vmp.pushNotificationSuperTitle = vmp.dataPost.meta.options.push_supertitle
          // }
          if(vmp.dataPost.meta.options.mobile_title) {
            vmp.mobileTitle = vmp.dataPost.meta.options.mobile_title
          }
          if(vmp.dataPost.meta.options.display_video) {
            vmp.videoBadge = true;
          }
          if(vmp.dataPost.meta.options.display_photo) {
            vmp.photoBadge = true;
          }
          if(vmp.dataPost.meta.options.display_live) {
            vmp.liveBadge = true;
          }
          if(vmp.dataPost.meta.options.by_comtrade) {
            vmp.displayByComtrade = true
          }
          if(vmp.dataPost.meta.options.copyright) {
            vmp.copyright = true
          }
        }
        if('recommended' in vmp.dataPost.meta) {
          vmp.recommendedNews = cleanArray.clean(vmp.dataPost.meta.recommended);
        }
        if('tnow_video_data' in vmp.dataPost.meta) {
          vmp.tnow_data = vmp.dataPost.meta.tnow_video_data;
        }

      }
      if(vmp.dataPost.display_writers) {
        vmp.displayWriters = true;
      } else {
        vmp.displayWriters = false;
      }
      if(vmp.dataPost.display_writer_initials) {
        vmp.displayWriterInitials = true;
      } else {
        vmp.displayWriterInitials = false;
      }
      if(vmp.dataPost.writers) {
        vmp.writers = vmp.dataPost.writers
      }
      if(!vmp.dataPost.tags) {
        vmp.dataPost.tags = [];
      } else {
        vmp.dataPost.tags = checkArray.removeDuplicate(vmp.dataPost.tags);
      }
      if(vmp.dataPost.recommended_poll) {
        vmp.recommendedPollObj = {
          _id : vmp.dataPost.recommended_poll._id,
          title: vmp.dataPost.recommended_poll.title
        }
      }
      vmp.selectedPostStatus={value:vmp.dataPost.status};

      var postContent = vmp.dataPost.content;
      // vmp.textEditorContent = vmp.dataPost.content;
      if(postContent) {
        postContent.replace(/\[caption([^\]].*?)\]([^\]]*?)\[\/caption\]/g, function(all, attr, con) {
            var parseOptions = parseOptionsFunc(attr);
            if(parseOptions.signature_url) {
              var signatureUrl = parseOptions.signature_url
            } else {
              var signatureUrl = ''
            }
            if(parseOptions.image_link) {
              var imageLink = 'image_link="'+parseOptions.image_link+'"'
            } else {
              var imageLink = ''
            }
            if(parseOptions.image_target_blank) {
              var imageTargetBlank = 'image_target_blank="'+parseOptions.image_target_blank+'"'   
            } else {
              var imageTargetBlank = ''
            }
            var imageLinkSummary = imageLink ? imageLink + (imageTargetBlank ? ' ' + imageTargetBlank : '') : '';
            postContent = postContent.replace( all,'<captionblock id="'+parseOptions.id+'" align="'+parseOptions.align+'" width="' +parseOptions.width +'" height="' +parseOptions.height +'" signature_url="'+ signatureUrl +'" '+imageLinkSummary+'>'+con+'</captionblock>');
        });
        postContent.replace(/\[gallery([^\]].*?)\]/g, function(all, attr) {
          var parseOptions = parseOptionsFunc(attr);
          postContent = postContent.replace( all,'<galleryblock ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' +parseOptions.title +'">[gallery ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' +parseOptions.title +'"]</galleryblock>');
        });
        postContent.replace(/\[embed\s+([^\]]*?)\]([\s\S]*?)\[\/embed\]/g, function(all, attr, con) {
          var parseOptions = parseOptionsFunc(attr);
          var type = parseOptions.type || parseOptions.src;
          postContent = postContent.replace( all,'<embedblock type="'+type+'">'+con+'</embedblock>');
        });
        postContent.replace(/\[summary\]([\s\S]*?)\[\/summary\]/g, function(all) {
            postContent = postContent.replace(all, '<summaryblock>' + all + '</summaryblock>');
        });
        postContent = wpautop(postContent);
        vmp.tinymceModel = postContent;
      }
      if(vmp.dataPost.comment_status == 'open') {
        vmp.allowcomments = true;
      } else {
        vmp.allowcomments = false;
      }
      if(!vmp.dataPost.comments_priority) {
        vmp.commentsPriority.value = '0';
      } else {
        vmp.commentsPriority.value = vmp.dataPost.comments_priority.toString();
      }
      if(vmp.dataPost.preview_hash) {
        vmp.previewHash = vmp.dataPost.preview_hash;
      }
      if(vmp.dataPost.slug) {
        vmp.postSlug = vmp.dataPost.slug;
        vmp.copySlug = angular.copy(vmp.postSlug); 
      }
      if(vmp.dataPost.slug && vmp.dataPost.url) {
        var slugLength = vmp.dataPost.slug.length;
        vmp.substringUri = vmp.dataPost.url.substr(0, vmp.dataPost.url.length-slugLength);
      }
      if(vmp.dataPost.image) {
        vmp.hasFeaturedImage = true;
        vmp.featured_img_obj = vmp.dataPost.image; 
        vmp.featured_img_id = vmp.dataPost.image._id;
      }
      if(vmp.dataPost.share_image) {
        vmp.shareImageObj = vmp.dataPost.share_image
      }
      if(vmp.dataPost.category) {
        vmp.category = vmp.dataPost.category._id;
        $timeout(function() {
          vmp.categoryIdOnLoad = vmp.dataPost.category._id
        },0) 
      }
      if(vmp.dataPost.description) {
        vmp.description_custom = vmp.dataPost.description.custom
        vmp.description_text =  vmp.dataPost.description.text
      }
      if(vmp.dataPost.videos && vmp.dataPost.videos.length>0) {
        if(typeof vmp.dataPost.videos[0] !== 'object' || vmp.dataPost.videos[0] === null) return
        vmp.featuredVideoObj = vmp.dataPost.videos[0];
        initializeFeaturedVideo(vmp.dataPost.videos[0])
      }
      if(vmp.dataPost.keywords && vmp.dataPost.keywords.length>0) {
        vmp.updateKeywords = false;
        $timeout(function() {
          vmp.updateKeywords = true;
        }, 200);
      } else {
        vmp.dataPost.keywords = [];
      }
      if(vmp.editPublish) {
        getRemainingTweets();
      }
    }
    
    if(vmp.postId) {
      if($rootScope.role_id == 'superadmin' || $rootScope.role_id == 'administrator' || parseInt(vmp.postId) < vmp.config.txt_mode_display) {
        vmp.textModePermision = true;
      }
      $rootScope.mediaComunicateWithEditPost= null;
      vmp.newPost = false;
      $rootScope.closeEditPost = function() {
        if(!vmp.singleView) return;
        $rootScope.hasLoaded = false;
        vmp.closeEditPostFlag = true;
        $rootScope.ngEscapeAttrsParametars = [];
        if(vmp.autosaveInterval) {
          $interval.cancel(vmp.autosaveInterval);
          vmp.autosaveInterval = null;
        }
        if(vmp.intervalHeartBeatPost) {
          $interval.cancel(vmp.intervalHeartBeatPost);
          vmp.intervalHeartBeatPost = null;
        }
        unlockPost()
      }

      var getPostData = function(type) {
        // add a version number to the request to avoid caching for restore post
        var v = new Date().getTime();
        getDataService.get({param1:'posts', param2: vmp.postId, v:v}).$promise.then(function(dataPosts){
          if(!vmp.singleView) return;
          vmp.dataPost = dataPosts;
          $rootScope.hasLoaded = true;
          if(!vmp.intervalHeartBeatPost) {
            vmp.intervalHeartBeatPost = $interval(vmp.intervalHeartBeatFunction,vmp.config.heartbeat.pulse*1000);
          }
          if(!vmp.autosaveInterval) {
            vmp.autosaveInterval = $interval(vmp.autoSaveFunction,vmp.config.heartbeat.autosave*1000);
          }
          vmp.intervalHeartBeatFunction();
          vmp.editPostFunction();
          if(vmp.dataPost.author == userId) {
            vmp.permissionsOwnPost = true;
          }
          vmp.assignTo = {value:vmp.dataPost.author.toString()};
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            if(type== 'save') {
              if(!vmp.intervalHeartBeatPost) {
                vmp.intervalHeartBeatPost = $interval(vmp.intervalHeartBeatFunction,vmp.config.heartbeat.pulse*1000);
              }
              if(!vmp.autosaveInterval) {
                vmp.autosaveInterval = $interval(vmp.autoSaveFunction,vmp.config.heartbeat.autosave*1000);
              }
            }
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {
                  getPostData();
                }
                // do something
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          } else if(error.status ==502) {
            serverError()
          } else {
            vmp.getPostDataError = true;
            parent.editPostShow = false;
            if(vmp.autosaveInterval) {
              $interval.cancel(vmp.autosaveInterval);
              vmp.autosaveInterval = null;
            }
            if(vmp.intervalHeartBeatPost) {
              $interval.cancel(vmp.intervalHeartBeatPost);
              vmp.intervalHeartBeatPost = null;
            }
            $state.transitionTo('app.'+ appState, {id: null}, {
              location: true,
              inherit: true,
              relative: $state.$current,
              notify: false
            });
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        });
      }
      var getCategoriesFunction = function(type) {
        $rootScope.hasLoaded = false;
        getDataService.get({param1:'categories', param2: null, tree:1, showinvisible:true}).$promise.then(function(dataCategory){
            if(!vmp.singleView) return;        
            vmp.categories = dataCategory.categories;
            if(type=='save') {
              getPostData('save');
            } else {
              getPostData();
            }
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            if(type== 'save') {
              if(!vmp.intervalHeartBeatPost) {
                vmp.intervalHeartBeatPost = $interval(vmp.intervalHeartBeatFunction,vmp.config.heartbeat.pulse*1000);
              }
              if(!vmp.autosaveInterval) {
                vmp.autosaveInterval = $interval(vmp.autoSaveFunction,vmp.config.heartbeat.autosave*1000);
              }
            }
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
                function(answer) {
                  if(answer==200) {
                    getCategoriesFunction();
                  }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          } else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        });
      }  
      getCategoriesFunction();
    } else {
      vmp.dataPost.status = 'draft';
      vmp.selectedPostStatus={value:'draft'};
      $rootScope.hasLoaded = true;
      var getNewPostData = function() {
        postDataService.save({
          param1:'posts' 
        }).$promise.then(function(data){
          if(!$state.is('app.newpost')) return;
            vmp.postId = data.post._id;
            vmp.previewHash = data.post.preview_hash;
            vmp.dataPost.order = data.post.order;
            vmp.dataPost.fixed_position = '';
            vmp.dataPost.meta = data.post.meta;
            vmp.dataPost.writers = data.post.writers;
            vmp.dataPost.display_writers = data.post.display_writers;
            vmp.intervalHeartBeatPost = $interval(vmp.intervalHeartBeatFunction,vmp.config.heartbeat.pulse*1000);
            vmp.autosaveInterval = $interval(vmp.autoSaveFunction,vmp.config.heartbeat.autosave*1000);
            vmp.intervalHeartBeatFunction();
            if(data.post.author == userId) {
              vmp.permissionsOwnPost = true;
            }
            if(vmp.dataPost.writers) {
              vmp.writers = vmp.dataPost.writers
            }
            if(vmp.dataPost.display_writers) {
              vmp.displayWriters = true;
            } else {
              vmp.displayWriters = false;
            }

        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {
                  getNewPostData();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          } else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
        });
      }
      var getCategoriesFunction = function() {
        getDataService.get({param1:'categories', param2: null, tree:1}).$promise.then(function(dataCategory){
          if(!$state.is('app.newpost')) return;
          vmp.categories = dataCategory.categories;
          getNewPostData(); 
            
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
                function(answer) {
                  if(answer==200) {
                    getCategoriesFunction();
                  }
                // do something
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          }
        });
      } 
      getCategoriesFunction();
      
    }
    var getAuthorsFunction = function() {
      getDataService.get({param1:'users', param2: 'all',status:1}).$promise.then(function(data){      
        vmp.allAuthors = data.users;
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          return
        }
        if(error.status == 401) {
          var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {
                  getAuthorsFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
              // report progress
              });
        } else if(error.status ==502) {
          serverError()
        }else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
      });
    }
    getAuthorsFunction();
    function getRemainingTweets() {
      $http.get(API_URL + 'posts/social/twitter/remaining-tweets').success(function(response) {
        vmp.shareOnXRemainingPosts = response.count;
      }).error(function (data, status, header, config) {
        if(status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {   
                getRemainingTweets();
              }
            },
            function(error) {
              // report something
            },
            function(progress) {
            // report progress
          });
        }else if(status ==502) {
          serverError();
        } else {  
          alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
        }
      });
    }
    vmp.shareOnX = function() {
      function shareOnX() {
        $http.post(API_URL + 'posts/social/twitter/send', {post_id: vmp.postId}).success(function(response) {
          vmp.shareOnXRemainingPosts = response.remaining;
          console.log(response);
          alertService('success','Success! ', response.message,2000);
        }).error(function (data, status, header, config) {
          if(status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  shareOnX();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          } else if(status ==502) {
            serverError();
          } else {
            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
          }
        });
      }
      shareOnX();
    }
    // Function to detect if there are unsaved changes (only for new posts)
    function detectChanges() {
      if (!vmp.newPost) return false; // Only check for new posts
      
      // Check if user has entered any content
      var hasContent = false;
      
      // Check title
      if (vmp.dataPost.title && vmp.dataPost.title.trim() !== '') {
        hasContent = true;
      }
      
      // Check content
      if (vmp.tinymceModel && vmp.tinymceModel.trim() !== '') {
        hasContent = true;
      }
      
      // Check subtitle
      if (vmp.dataPost.subtitle && vmp.dataPost.subtitle.trim() !== '') {
        hasContent = true;
      }
      
      // Check page title
      if (vmp.dataPost.page_title && vmp.dataPost.page_title.trim() !== '') {
        hasContent = true;
      }
      
      // Check if category is selected
      if (vmp.category && vmp.category !== 'uncategorized') {
        hasContent = true;
      }
      
      // Check if tags are added
      if (vmp.dataPost.tags && vmp.dataPost.tags.length > 0) {
        hasContent = true;
      }
      
      // Check if featured image is set
      if (vmp.hasFeaturedImage) {
        hasContent = true;
      }
      
      vmp.hasUnsavedChanges = hasContent;
      return hasContent;
    };
    
    // Function to show warning when navigating away (for internal navigation only)
    function showNavigationWarning(event, toState, toParams) {
      if (!vmp.newPost) return; // Only for new posts

      if (detectChanges()) {

        warningAlertService('Unsaved Changes',
          'You have unsaved changes. Are you sure you want to leave without saving?',
          function cb() {
            // User confirmed - allow navigation
            vmp.isNavigatingAway = true;
            vmp.hasUnsavedChanges = false;
            // Programmatically navigate to the intended state
            if (toState && toState.name) {
              // Use $timeout to ensure this runs after the current event cycle
              $timeout(function() {
                $state.go(toState.name, toParams)
              },0);
            }
          },
          function() {
            // User cancelled - prevent navigation
            vmp.isNavigatingAway = false;

            // For other events, we can prevent navigation
            if (event && event.preventDefault) {
              event.preventDefault();
            }
          }
        );
      }
    };
    // Add watchers to detect changes in real-time (only for new posts)
    if (vmp.newPost) {
      // Watch for changes in title
      $scope.$watch('vmp.dataPost.title', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          detectChanges();
        }
      });
      
      // Watch for changes in content
      $scope.$watch('vmp.tinymceModel', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          detectChanges();
        }
      });
      
      // Watch for changes in subtitle
      $scope.$watch('vmp.dataPost.subtitle', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          detectChanges();
        }
      });
      
      // Watch for changes in page title
      $scope.$watch('vmp.dataPost.page_title', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          detectChanges();
        }
      });
      
      // Watch for changes in category
      $scope.$watch('vmp.category', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          detectChanges();
        }
      });
      
      // Watch for changes in tags
      $scope.$watch('vmp.dataPost.tags', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          detectChanges();
        }
      }, true);
      
      // Watch for changes in featured image
      $scope.$watch('vmp.hasFeaturedImage', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          detectChanges();
        }
      });

      // Listen for state changes to warn about unsaved changes (only for new posts)
      $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        if (toState.name == 'login') return
        if (vmp.isNavigatingAway) return
        if (!detectChanges()) return 
        event.preventDefault();
        showNavigationWarning(event, toState, toParams);
      });
    }

    function unlockPost(type) {
      if(vmp.getPostDataError) return
      $http.delete(API_URL + 'posts/' + vmp.postId + '/unlock').success(function(data){
        if(!vmp.closeEditPostFlag) return
        // If the post is being closed, we have race condition bettwen unlockPost and getAllPosts
        $rootScope.hasLoaded = true;
        parent.editPostShow = false;
        vmp.dataPost = null;
        $state.transitionTo('app.'+appState, {id: null}, {
            location: true,
            inherit: true,
            relative: $state.$current,
            notify: false
        });
      }).error(function (data, status, header, config) {
        if(status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {   
                unlockPost(type);
              }
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
          });
        }else if(status ==502) {
          serverError();
        } else {  
          alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
        }
        if(vmp.closeEditPostFlag) {
          $rootScope.hasLoaded = true;
        }
      });
    }
    // Define the beforeunload handler function
    function beforeUnloadHandler(event) {
      // For new posts, check for unsaved changes
      if (vmp.newPost && detectChanges()) {
        // For beforeunload, we can only show browser's native warning
        event.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
        return event.returnValue;
      }
      
      // For existing posts, just unlock
      if (!vmp.newPost) {
        unlockPost('beforeunload');
      }
    };
    // Handle cleanup when user closes tab/browser
    window.addEventListener('beforeunload', beforeUnloadHandler);
    // Handle cleanup when Angular scope is destroyed (navigation, etc.)
    $scope.$on('$destroy', function() {
      // Remove the beforeunload listener to prevent memory leaks
      window.removeEventListener('beforeunload', beforeUnloadHandler);
      
      vmp.disposeVideo();
      // Make sure that the interval is destroyed too
      // watchCategory();
      if(vmp.intervalHeartBeatPost) {
        $interval.cancel(vmp.intervalHeartBeatPost);
      }
      if(vmp.autosaveInterval) {
        $interval.cancel(vmp.autosaveInterval);
      }
      vmp.intervalHeartBeatPost = null;
      vmp.autosaveInterval = null;
      vmp.autoSaveFunction = null;
      vmp.intervalHeartBeatFunction = null;
      vmp.singleView = null;
      if(eventStream.hasMessageHandler(streamTaxonomy,takeoverCallback)) {
        eventStream.offMessage(streamTaxonomy,takeoverCallback);
      }
      // In destroy call unlockPost if we're not closing the browser
      // (beforeunload will handle browser close)
      if(!vmp.newPost && !vmp.closeEditPostFlag) {
        unlockPost();
      }
    });
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/edit-newpost/js/postController.js
// module id = 564
// module chunks = 0